import { Component, Optional, Inject, Input, ViewChild, OnChanges, SimpleChanges, OnInit, ElementRef } from '@angular/core';
import { NgModel, NG_VALUE_ACCESSOR, NG_VALIDATORS, NG_ASYNC_VALIDATORS, Validators, FormGroup, FormBuilder, } from '@angular/forms';
import { ElementBase } from 'src/app/core/form/element-base';
import { debounceTime, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { StringUtilityServ } from 'src/app/core/services/utilities/string.service';
import { MenuComponent } from '../../../inputs/menu/menu.component';

@Component({
  selector: 'app-pt-dest-bus',
  templateUrl: './pt-dest-bus.component.html',
  styleUrls: ['./pt-dest-bus.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: PtDestBusComponent, multi: true }
  ],
})
export class PtDestBusComponent extends ElementBase<any> implements OnInit {


  @Input() public placeholder: string;
  @Input() public data: any;
  @Input() public icon: boolean = true;
  @Input() public mobileMode: boolean;
  @Input() public submited: boolean;
  @ViewChild(NgModel) model: NgModel;
  @ViewChild('tg') tg: ElementRef;
  @ViewChild('menuModal') menuModal: MenuComponent;
  public busList: any;
  public form: FormGroup;
  public dataFiltred: any;
  public valueInpt: string;
  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    private fb: FormBuilder,
    private strServ: StringUtilityServ
  ) {
    super(validators, asyncValidators);
  }

  ngOnInit() {
    this.busList = this.data;
  }
  formatter = (x: { name: string }) => x && typeof x != 'string' ? x.name : x || '';
  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => {
        if (term === '') {
          return [];
        }
        return this.filterGroupAirport(term);
      })
    )

  filterGroupAirport(term: any) {
    let filter = this.busList.filter(f => {
      if (this.strServ.ecualsNoAcents(f.name, term)) {
        return true;
      }
      return false;
    });

    console.log("Filtro: ", filter)
    // filter.sort((a, b) => {
    //   return a.priority - b.priority;
    // });
    this.dataFiltred = this.resaltTerm(filter.slice(0, 8), term);
    return this.dataFiltred;
  }
  resaltTerm(data, term) {
    if (!this.mobileMode) {
      return data;
    }
    data.forEach(e => {
      e.newTitle = this.strServ.strAutocompl(e.name, term);
      // e.newSubtitle = this.strServ.strAutocompl(e.label, term);
    });
    return data;
  }
  clickInput() {
    const vl: any = this.value.name ? this.value.name : '';
    this.valueInpt = vl;
    this.filterGroupAirport(vl);
  }
  changeInput(event) {
    this.filterGroupAirport(this.valueInpt);
  }
  setValueSelected(data) {
    this.value = data;
    this.closeModal();
  }
  closeModal() {
    this.menuModal.closeMenu();
    this.valueInpt = '';
  }
  checkFocus() {
    this.tg.nativeElement.focus();
  }

}
